import useAssessmentCategory from './useAssessmentCategory'
import useInsertion from './useInsertion'
import useTimePoint from './useTimePoint'
import useEnd from './useEnd'
import useOmission from './useOmission'
import useError from './useError'
import useRepitition from './useRepitition'
import useSettingsItems from './useSettingsItems'
import useMarkerTypes from './useMarkerTypes'
import useSetCheckingStatus from './useSetCheckingStatus'

export default { useMarkerTypes, useSetCheckingStatus, useError, useRepitition, useOmission, useSettingsItems, useEnd, useAssessmentCategory, useInsertion, useTimePoint }